<template>
    <div class="p-5">
        <div class="w-auto">
            <div class="mb-5">
                <h4 class="mb-3">CGV</h4>
                <v-text-field
                  outlined
                  v-model="configCaguName"
                  hide-details
                  label="Nom du lien du document"
                ></v-text-field>

                <v-text-field
                  outlined
                  v-model="configCguEndText"
                  hide-details
                  label="Engagement textuel"
                ></v-text-field>
            </div>

            <div class="mb-5">
                <h4 class="mb-3">Espace-pro</h4>
                <v-checkbox class="mx-auto mb-auto" style="padding-top: 0!important;"
                            label="La sollicitation porte le nom de la campagne"
                            v-model="configCadhTitleInterfacePro"
                            true-value="1"
                            false-value="0"
                            hide-details>
                </v-checkbox>
            </div>

            <div class="mb-5">
                <h4 class="mb-3">Document récapitulatif de la réponse</h4>
                <v-text-field
                  outlined
                  hide-details
                  label="Titre du document (par défaut contrat d'adhésion ou contrat de partenariat)"
                  v-model="configPdfTitle"
                ></v-text-field>
            </div>

            <div class="mb-5">
                <h4 class="mb-3">Comportement du bulletin (optionnel)</h4>
                <v-checkbox class="mx-auto mb-auto" style="padding-top: 0!important;"
                            label="Une offre doit être sélectionnée pour afficher les options"
                            v-model="configOneOfferToShowOptions"
                            true-value="1"
                            false-value="0"
                            hide-details>
                </v-checkbox>

                <v-checkbox class="mx-auto mb-auto" style="padding-top: 0!important;"
                            label="Une offre doit être sélectionnée pour afficher les informations"
                            v-model="configOneOfferToShowInformations"
                            true-value="1"
                            false-value="0"
                            hide-details>
                </v-checkbox>
            </div>

        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
    name: "AdvancedParameters",
    data() {
        return {
            canWatch: false,
        }
    },
    methods: {
        ...mapMutations("cadhConfig", ["setParameterCurrentStep", "setCguName", "setCguEndText",
            "setCadhTitleInterfacePro", "setOneOfferToShowOptions", "setOneOfferToShowInformations", "setPdfTitle"]),
        updateKey(payload) {
            this.$global.loading = true

            this.$store.dispatch("cadhConfig/updateConfigurationKey", payload)

            this.$global.loading = false
        },
        updateCguName() {
            let payload = {
                "configId": this.cadhConfig.id,
                "key": "cgu_link_text",
                "value": this.cguName,
            }

            this.updateKey(payload)
        },
        updateCadhTitleInterfacePro() {
            let payload = {
                "configId": this.cadhConfig.id,
                "key": "cadh_title_interface_pro",
                "value": this.cadhTitleInterfacePro,
            }

            this.updateKey(payload)
        },
        updateCguEndText() {
            let payload = {
                "configId": this.cadhConfig.id,
                "key": "cgu_end_text",
                "value": this.cguEndText,
            }

            this.updateKey(payload)
        },
        updateOneOfferToShowOptions() {
            let payload = {
                "configId": this.cadhConfig.id,
                "key": "one_offer_to_show_options",
                "value": this.oneOfferToShowOptions,
            }

            this.updateKey(payload)
        },
        updatePdfTitle() {
            let payload = {
                "configId": this.cadhConfig.id,
                "key": "answer_pdf_title",
                "value": this.pdfTitle,
            }

            this.updateKey(payload)
        },
        updateOneOfferToShowInformations() {
            let payload = {
                "configId": this.cadhConfig.id,
                "key": "one_offer_to_show_informations",
                "value": this.oneOfferToShowInformations,
            }

            this.updateKey(payload)
        },
    },
    computed: {
        ...mapState("cadhConfig", ["cadhConfig", "parameterCurrentStep", "cguName", "cguEndText",
            "cadhTitleInterfacePro", "oneOfferToShowOptions", "oneOfferToShowInformations", "pdfTitle"]),
        configCaguName: {
            get() {
                return this.cguName
            },
            set(value) {
                this.setCguName(value)
            },
        },
        configCguEndText: {
            get() {
                return this.cguEndText
            },
            set(value) {
                this.setCguEndText(value)
            },
        },
        configCadhTitleInterfacePro: {
            get() {
                return this.cadhTitleInterfacePro
            },
            set(value) {
                this.setCadhTitleInterfacePro(value)
            },
        },
        configOneOfferToShowOptions: {
            get() {
                return this.oneOfferToShowOptions
            },
            set(value) {
                this.setOneOfferToShowOptions(value)
            },
        },
        configOneOfferToShowInformations: {
            get() {
                return this.oneOfferToShowInformations
            },
            set(value) {
                this.setOneOfferToShowInformations(value)
            },
        },
        configPdfTitle: {
            get() {
                return this.pdfTitle
            },
            set(value) {
                this.setPdfTitle(value)
            },
        },
    },
    watch: {
        cguName() {
            if (this.canWatch) {
                this.updateCguName()
            }
        },
        cguEndText() {
            if (this.canWatch) {
                this.updateCguEndText()
            }
        },
        cadhTitleInterfacePro() {
            if (this.canWatch) {
                this.updateCadhTitleInterfacePro()
            }
        },
        oneOfferToShowOptions() {
            if (this.canWatch) {
                this.updateOneOfferToShowOptions()
            }
        },
        oneOfferToShowInformations() {
            if (this.canWatch) {
                this.updateOneOfferToShowInformations()
            }
        },
        pdfTitle() {
            if (this.canWatch) {
                this.updatePdfTitle()
            }
        },
    },
    updated() {
        this.canWatch = true
    },
}
</script>